// https://nuxtjs.org/api/pages-key/
// https://nuxtjs.org/api/components-nuxt
// NOTE: ignore hash and query, but take path into account
export default ({ path, query }) => [path].filter(Boolean).join('?');
